import img_2 from "../../images/RABBIT LIFE LOGO with insurance-02.png";
import { IoIosCall } from "react-icons/io";
import { FaLine } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import line from "../../images/LINE_Brand_icon.png";
import facebook_Logo from "../../images/Facebook_Logo.png";
import { useEffect } from "react";
import "../Login/maintenance-styles.css";
const Maintanance = ({ start, end, listServer = [] }) => {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto"; // restore on unmount
    };
  }, []);
  return (
    <div className="downtime-container">
      <div style={{ display: "flex", justifyContent: "center" }}>
        <img className="img-fluid" src={img_2} alt="" width={"250"} />
      </div>
 
      <div className="main-banner">บริษัทฯ ขอแจ้งปิดระบบ iService ชั่วคราว</div>
      <div className="main-banner">
        เพื่อเพิ่มประสิทธิภาพการใช้งานที่ดียิ่งขึ้น
      </div>
      <br />
 
      <div className="notice-bar">
        {`วันที่ ${start}`} <br />
        {`ถึงวันที่ ${end}`}
      </div>
 
      <br />
      <div className="main-banner" style={{ fontSize: 24 }}>
        ขออภัยในความไม่สะดวกมา ณ ที่นี้
      </div>
 
      <div
        style={{
          fontSize: 18,
          color: "#FF7F50",
          marginBottom: 27,
          textAlign: "center",
        }}
      >
        กรณีที่ท่านต้องการสอบถาม และความช่วยเหลือเพิ่มเติม สามารถติดต่อได้ที่
      </div>
      <div className="contact-info-box">
        <div className="contact-item">
          <MdEmail size={20} />
          <span>CS@rabbitlife.co.th</span>
        </div>
 
        <div className="contact-item">
          <img src={line} alt="Line" />
          <span>@Rabbit_life</span>
        </div>
 
        <div className="contact-item">
          <img src={facebook_Logo} alt="Facebook" />
          <span>: Rabbitlife</span>
        </div>
      </div>
    </div>
  );
};
 
export default Maintanance;